// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Represents a type of effect - like poison - that can be
 * applied to an entity.
 */
export default class EffectType {
  /**
   * @remarks
   * Identifier name of this effect type.
   * @returns
   * Identifier of the effect type.
   */
  getName(): string {
    return "";
  }
}
